import React from "react";
import Breadcrumb from "../../../../core/common/Breadcrumb/breadcrumb";
import SettingsLinks from "../settingsLinks/settingsLinks";
import ProfileCard from "../../common/profileCard";
import StudentSidebar from "../../common/studentSidebar";
import { useTranslation } from "react-i18next";

const StudentSocialProfile = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="content">
        <div className="container">
          {/* profile box */}
          <ProfileCard />
          {/* profile box */}
          <div className="row">
            {/* sidebar */}
            <StudentSidebar />
            {/* sidebar */}
            <div className="col-lg-9">
              <Breadcrumb title={t("socialProfile.title")} />
              <div className="mb-3">
                <h5>{t("socialProfile.title")}</h5>
              </div>
              <SettingsLinks />
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <form>
                        <div className="mb-3">
                          <label className="form-label">
                            {t("socialProfile.twitter")}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="https://www.twitter.com/"
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            {t("socialProfile.facebook")}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="https://www.facebook.com/"
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            {t("socialProfile.instagram")}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="https://www.instagram.com/"
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            {t("socialProfile.linkedin")}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="https://www.linkedin.com/"
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            {t("socialProfile.youtube")}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="https://www.youtube.com/"
                          />
                        </div>
                        <div className="mt-4">
                          <button className="btn btn-secondary" type="submit">
                            {t("socialProfile.save")}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentSocialProfile;
